import Banner from '../../../common/components/Banner';
import CkEditorContent from '../../../common/components/CkEditorContent';
import React from 'react';
import TaskTilesSection from './../TaskTilesSection';
import { Box, Grid } from '@material-ui/core';
import { TaskListLayoutProps } from '../../interfaces';
import { TaskListStyles } from '../../styles';
import TaskListMobilePopup from '../../../shlApp/components/TaskListMobilePopup';
import { SHLApp } from '../../../constants/shlapp';
import { SessionStore } from '../../../constants/sessionStore';

/**
 * TaskListLayout
 * - Layout Container for Banner, CkEditorContent and TaskTilesSection
 */
const TaskListLayout01 = (props: TaskListLayoutProps): JSX.Element => {
  const { isICPEnabled, showTileBanner, taskListConfiguration, desktopAssessments, tasks } = props;

  const {
    sequential,
    styles: { bannerImageEnabled, bannerImage, content },
    feedbackPage,
  } = taskListConfiguration;

  const isSHLAppAgent = navigator.userAgent.indexOf(SHLApp.IS_SHLAPP_AGENT) === -1;
  const isSHLAndroidAgent = navigator.userAgent.indexOf(SHLApp.IS_SHLAPP_ANDROID_AGENT) > -1;
  const isSHLIOSAgent = navigator.userAgent.indexOf(SHLApp.IS_SHLAPP_IOS_AGENT) > -1;
  const hashTaskList = window.location.hash.indexOf(SHLApp.IS_TASK_LIST) > -1;
  const isAppPrompt = sessionStorage.getItem(SessionStore.isAppPrompt) === 'true';

  const classes = TaskListStyles({ ...taskListConfiguration.styles, isICPEnabled });

  return (
    <Box className={classes.container}>
      {isSHLAppAgent && isAppPrompt && !hashTaskList && desktopAssessments && <TaskListMobilePopup />}
      {isSHLAppAgent && !isAppPrompt && hashTaskList && desktopAssessments && <TaskListMobilePopup />}
      {(isSHLAndroidAgent || isSHLIOSAgent) && desktopAssessments && <TaskListMobilePopup />}

      {bannerImageEnabled && bannerImage && <Banner src={bannerImage.path} alt={bannerImage.name} />}
      <Grid container justify="center" className={`${classes.contentContainer} ${classes.contentSpacing}`}>
        {content && (
          <Grid item lg={10}>
            <CkEditorContent content={content} pageStartTime={new Date()} generalContentName="Task List" />
          </Grid>
        )}
        <TaskTilesSection
          sequential={sequential}
          showTileBanner={showTileBanner}
          styles={taskListConfiguration.styles}
          tasks={tasks}
          feedbackPage={feedbackPage}
        />
      </Grid>
    </Box>
  );
};

export default TaskListLayout01;
